import templateUrl from 'emun.salesrep/salesrep-sales-goals-full.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config';

class SalesRepSalesGoalsFullController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		var context = $ctrl.context || 'executive';
		$ctrl.utils = utils;

		var repFilter = "";
		if (context === 'manager') {
			repFilter = "&ManagerId=" + $ctrl.rep.id;
		}

		if ($ctrl.repGroup !== 'ALL' && $ctrl.repGroup && $ctrl.repGroupId) {
			repFilter = '&RepGroup=' + $ctrl.repGroupId;
		}

		//        var url = 'QueryOrderLineTotals.json?dateRange=YTD&grouping=strCategory' + repFilter;
		var url = 'QuerySalesYOYTotals.json?Sum=TotalSalesWeekToDate,TotalSalesWeekToDateLastYear,TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate&GroupBy=SalesRepId,SalesRepName' + repFilter;

		if ($ctrl.repGroup !== 'ALL' && $ctrl.repGroup) {
			url = url + '&RepGroupName=' + $ctrl.repGroup;
		}
		if ($ctrl.insideSales === 'true') {
			url = url + '&IsInsideSales=true';
		}
		$ctrl.salesTotals = createAutoQuery({
			url: url,
			autoLoad: true,
			take: 1000,
			onLoaded: function (totals) {
				var salesGoalsUrl = 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisQuarter,SalesGoalThisYear&GroupBy=SalesRepId';
				if ($ctrl.repGroup) {
					if ($ctrl.repGroup !== 'ALL') {
						salesGoalsUrl = salesGoalsUrl + '&RepGroupName=' + $ctrl.repGroup;
					}
				}
				if ($ctrl.insideSales !== 'true') {
					salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=false';
				}
				$ctrl.salesGoals = createAutoQuery({
					url: salesGoalsUrl,
					autoLoad: true,
					take: 1000,
					onLoaded: function (goals) {
						totals.results.forEach(function (total) {
							total.goalThisMonth = 0;
							total.goalThisQuarter = 0;
							total.goalThisYear = 0;
							goals.results.forEach(function (goal) { 
								if (total.salesRepId === goal.salesRepId) {
									total.goalThisYear += goal.sumSalesGoalThisYear;
									total.goalThisMonth += goal.sumSalesGoalThisMonth;
									total.goalThisQuarter += goal.sumSalesGoalThisQuarter;
									if (total.goalThisYear > 0) {
										total.percentThisYear = Math.round((total.sumTotalSalesYearToDate / total.goalThisYear) * 100);
									} else {
										total.percentThisYear = 0;
									}
									if (total.goalThisMonth > 0) {
										total.percentThisMonth = Math.round((total.sumTotalSalesMonthToDate / total.goalThisMonth) * 100);
									} else {
										total.percentThisMonth = 0;
									}
									if (total.goalThisQuarter > 0) {
										total.percentThisQuarter = Math.round((total.sumTotalSalesQuarterToDate / total.goalThisQuarter) * 100);
									} else {
										total.percentThisQuarter = 0;
									}
								}
							});
						});
					}
				});
			}
		});
	}
	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			name: 'Sales Rep',
			wtdSales: "This Week",
			mtdSales: "This Month",
			mtdGoal: "Goal This Month",
			mtdGoalPercent: "% of Goal",
			qtdSales: "This Quarter",
			qtdGoal: "Goal This Quarter",
			qtdGoalPercent: "% of Goal",
			ytdSales: "This Year",
			ytdGoal: "Goal This Year",
			ytdGoalPercent: "% of Goal"
		};

		// format the data
		$ctrl.salesTotals.results.forEach((item) => {
			itemsFormatted.push({
				name: item.salesRepName.replace(/,/g, ''), // remove commas to avoid errors,
				wtdSales: item.sumTotalSalesWeekToDate,
				mtdSales: item.sumTotalSalesMonthToDate,
				mtdGoal: item.goalThisMonth,
				mtdGoalPercent: item.percentThisMonth,
				qtdSales: item.sumTotalSalesQuarterToDate,
				qtdGoal: item.goalThisQuarter,
				qtdGoalPercent: item.percentThisQuarter,
				ytdSales: item.sumTotalSalesYearToDate,
				ytdGoal: item.goalThisYear,
				ytdGoalPercent: item.percentThisYear
			});
		});

		var fileTitle = 'salesrep-sales';
		$ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'ytdSales').reverse(), fileTitle);
	}
}

let SalesRepSalesGoalsFull = {
	bindings: {
		rep: '<',
		repGroup: '@',
		repGroupId: '@',
		context: '@',
		mode: '@',
		insideSales: '@',
		writingRepId: '@'
	},
	//require:{
	//    container: '^salesrepDashboard'
	//},
	controller: SalesRepSalesGoalsFullController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default SalesRepSalesGoalsFull;